import { useMutation } from "@tanstack/react-query";
import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Estado } from "../../actions/Estado";
import {TipoInsumo} from '../../actions/tipoinsumo'
import style from "../../styles/form.module.css";

function ABMServicios() {
   var metodo = "POST";
   const token = localStorage.getItem("token");
   var url = process.env.REACT_APP_URL_DIR + "servicio";
   const location = useLocation();
   const { state } = location;
   const estados = Estado();
   const tipoinsu = TipoInsumo()
   const navigate = useNavigate();
   const [input, setInput] = useState({
      id: state ? state.id : 0,
      companyId: state ? state.companyId : 0,
      descripcion: state ? state.descripcion : "",
      precio: state ? state.precio : 0,
      tipo: state ? state.tipo : 1,
      cod_status: state ? state.cod_status : "1",
   });

   var btnGrabar = true;

   function handleChange(e) {
      e.preventDefault();
      setInput({
         ...input,
         [e.target.name]: e.target.value,
      });
   }

   function handleStatus(e) {
      e.preventDefault();
      setInput({
         ...input,
         cod_status: e.target.value,
      });
   }

   const handleSubmit = (e) => {
      e.preventDefault();
      console.log("input: ", input);
      if (input.cod_status === 0) {
         alert("Debe Ingresar un Status");
         return;
      }
      if (input.id === 0) {
         metodo = "POST";
      } else {
         metodo = "PUT";
         url += `/${input.id}`
      }
      console.log('metodo: ', metodo);
      mutate(input);
   };

   const { mutate } = useMutation({
      mutationFn: (newPost) =>
         fetch(url, {
            method: metodo,
            body: JSON.stringify(newPost),
            headers: {
               Authorization: `Bearer ${token}`,
               "Content-Type": "application/json",
            },
         }).then((res) => res.json()),
      onSuccess: () => {
         // console.log('url`: ', url + `/${newPost.id}`)
         // console.log('newPost: ', newPost);
         //queryClie nt.invalidateQueries({queryKey:["posts"]})  REFRESCA TODA LA DATA
         // queryClient.setQueryData(["posts"], (oldPosts) => [
         //    ...oldPosts,
         //    newPost,
         // ]);
          window.location.href = "/servicio";
      },
      onError: (error) => {
         alert(error);
      },
   });

   return (
      <>
         <div className={style.container}>
            <div className="bg-white w-90">
               <form
                  onSubmit={(e) => handleSubmit(e)}
                  // className="form-style-Prod"
               >
                  <h1 className="justify-self-center">Editar Servicio</h1>
                  <br />
                  <div>
                     {input.id !== 0 ? (
                        <div>
                           <span className={style.input_group_text}>
                              Servicio id : {input.id}
                           </span>
                           <br />
                        </div>
                     ) : null}
                  </div>

                  <div className={style.input_group}>
                     <span className={style.input_group_text}>
                        Descripción{" "}
                     </span>
                     <input
                        className={style.input_field}
                        type="text"
                        placeholder="Descripcion Servicio"
                        name="descripcion"
                        value={input.descripcion}
                        onChange={handleChange}
                        required
                     />
                  </div>

                  <div className={style.input_group}>
                     <span className={style.input_group_text}>Precio:</span>
                     <label htmlFor="precio"></label>
                     <input
                        type="number"
                        id="precio"
                        name="precio"
                        value={input.precio}
                        onChange={handleChange}
                        className={style.input_field_number}
                     />
                  </div>
                  <div className={style.input_group}>
                     <span className={style.input_group_text}>Tipo de Servicio:</span>
                     <select
                        name="tipo"
                        id="tipo"
                        onChange={(e) => handleChange(e)}
                        value={input.tipo}
                        className={style.input_field}
                     >
                        <option value="0">Seleccionar</option>
                        {tipoinsu &&
                           tipoinsu.map((ins) => {
                              return (
                                 <option
                                    selected
                                    value={ins.id}
                                    key={ins.id}
                                 >{`${ins.nombre}`}</option>
                              );
                           })}{" "}
                     </select>
                  </div>
                  <div className={style.input_group}>
                     <span className={style.input_group_text}>Status:</span>
                     <select
                        name="cod_status"
                        id="cod_status"
                        onChange={(e) => handleStatus(e)}
                        value={input.cod_status}
                        className={style.input_field}
                     >
                        <option value="0">Seleccionar</option>
                        {estados &&
                           estados.map((dat) => {
                              return (
                                 <option
                                    selected
                                    value={dat.id}
                                    key={dat.id}
                                 >{`${dat.nombre}`}</option>
                              );
                           })}{" "}
                     </select>
                  </div>
                  <div>
                     {btnGrabar ? (
                        <button className={style.inputBtnNew} type="submit">
                           {state ? "GRABAR" : "AGREGAR"}
                        </button>
                     ) : null}
                     &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                     <button
                        className={style.inputBtnNew}
                        onClick={() => {
                           navigate("/servicio");
                        }}
                     >
                        VOLVER
                     </button>
                  </div>
               </form>
            </div>
         </div>
      </>
   );
}

export default ABMServicios;
